"use client";
import { getBannersComponent } from "@/src/api/services/component";
import { HomePage as ClientHomePage } from "./components/HomePage";

export const HomePage = async () => {
  const banners = (await getBannersComponent())?.[0]?.props?.options || [];

  return <ClientHomePage banners={banners} />
};
